import React from 'react';
import { TimeAgo } from 'emergency_data/src/components/AdditionalData/EllingtonCard/TimeAgo';
import styled from 'styled-components';
import Box from '@rsos/components/capstone/base/Box';
import Text from '@rsos/components/capstone/base/Text';
import { parseSchema } from '@rsos/ellington';

export const StyledMapCardHeader = styled(Box)`
  margin-bottom: ${({ noMargin }) => (noMargin ? '0' : '11px')};
`;

const MapCardHeader = ({
  displaySchema: schema,
  data,
  layer,
  timestamp,
  title: fallbackTitle,
  noMargin,
  wrapHeader = true,
}) => {
  // Use the display schema's title interpolation and the description, otherwise
  // fallback to fallbackTitle then `N/A` and spatialLayer.source respectively
  const displaySchema = parseSchema(schema, data);

  let title, description;
  ({ title, description } = displaySchema);

  // If fallbackTitle is not truthy, title will default to `N/A` from the interpolation
  if ((!title || title === 'N/A' || title === 'undefined') && !!fallbackTitle) {
    title = fallbackTitle;
  }

  if (!description) {
    description = `Source: ${layer.source}`;
  }

  return (
    <StyledMapCardHeader noMargin={noMargin}>
      <Text
        size="normal"
        fontWeight="bold"
        color="primaryText"
        ellipsis={!wrapHeader}
        pr="18px"
      >
        {title}
      </Text>
      <Text size="xsmall" color="primaryText" ellipsis={!wrapHeader}>
        {description}
        {!!timestamp && (
          <>
            , <TimeAgo timestamp={timestamp} />
          </>
        )}
      </Text>
    </StyledMapCardHeader>
  );
};

export default MapCardHeader;
